/*
  HBV's card controls, one script for the page (carry-over from The Vape Shop, 2026-11-03). These were an inline onclick on
  every dropdown option and a <script> per card; the handlers sit on the document, so cards added by infinite scroll or a
  filter work with no re-binding.
*/
(function () {
  if (window.veStore) return;
  window.veStore = true;

  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;

    const trigger = t.closest('.ve-dropdown-trigger');
    if (trigger) {
      const box = trigger.parentNode;
      const wasOpen = box.classList.contains('ve-open');
      document.querySelectorAll('.ve-custom-dropdown.ve-open').forEach((d) => d.classList.remove('ve-open'));
      if (!wasOpen) box.classList.add('ve-open');
      return;
    }

    const option = t.closest('.ve-dropdown-option');
    if (option) {
      const form = option.closest('form');
      const card = option.closest('.ve-unified-brutalist-card');
      form.querySelector('input[name="id"]').value = option.dataset.id;
      const price = card.querySelector('.ve-card-price');
      if (price) price.textContent = option.dataset.price;
      card.querySelector('.ve-selected-text').textContent = option.textContent.trim();
      option.closest('.ve-custom-dropdown').classList.remove('ve-open');
      return;
    }

    const step = t.closest('.ve-qty-btn');
    if (step) {
      const input = step.parentNode.querySelector('input');
      if (step.dataset.step === 'down') input.stepDown();
      else input.stepUp();
      return;
    }

    if (!t.closest('.ve-custom-dropdown')) {
      document.querySelectorAll('.ve-custom-dropdown.ve-open').forEach((d) => d.classList.remove('ve-open'));
    }
  });
})();
